import { createFileRoute } from "@tanstack/react-router";
import DepressionAnxietyInsomnia from "@/pages/DepressionAnxietyInsomnia";
export const Route = createFileRoute("/depression-anxiety-insomnia")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Depression Anxiety Insomnia | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "When depression, anxiety, and insomnia overlap, treatment can help. Learn about TMS and SAINT TMS for complex symptoms in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Depression Anxiety Insomnia | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "When depression, anxiety, and insomnia overlap, treatment can help. Learn about TMS and SAINT TMS for complex symptoms in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/depression-anxiety-insomnia",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/depression-anxiety-insomnia",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionAnxietyInsomnia />;
}
